export default {
    apiKey: "AIzaSyAi3LVYGfvOiI8SC8VFiK1xEcnKiiIJCf8",
    authDomain: "project-26e3cab4-6d78-4fb2-828.firebaseapp.com",
    projectId: "project-26e3cab4-6d78-4fb2-828",
    storageBucket: "project-26e3cab4-6d78-4fb2-828.firebasestorage.app",
    messagingSenderId: "118355067035",
    appId: "1:118355067035:web:cbad11b90917baec0d863e"
};